<script>
	import EditorBasket from './Editor/Basket.svelte';
	import EditorWarning from './Editor/Warning.svelte';
	import Gallery from './Gallery.svelte';
	import Header from './Header.svelte';
	import Layout from '../Stores/Layout';
	import Loader from './Loader.svelte';
	import Media from './Media.svelte';
	import Menu from '../Stores/Menu';
	import Next from '../Stores/Next';
	import Product from '../Stores/Product';
	import Products from './Products.svelte';
	import Registry from '../Stores/Registry';
	import Steps from './Steps.svelte';
	import StoresBasket from '../Stores/Basket';
	import Styles from './Styles.svelte';
	import Toolbar from './Toolbar.svelte';
	import Widget from '../Stores/Widget';
	import {onMount} from 'svelte';

	export let shop;
	export let product;
	export let session;
	export let seller;
	export let basket;
	export let resource;

	let menu = false;
	let container = {};
	let editor = {};
	let next = {};

	$Registry.shop = shop;
	$Registry.seller = !!parseInt(seller);

	function containerSize() {
		const total = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
		const top = container.getBoundingClientRect().top;
		const height = Math.round(total - top);
		container.style.height = `${height}px`;
	}

	function editorScroll() {
		editor.scrollTop = 0;
	}

	function menuScroll(code) {
		const header = 60;
		const base = jQuery(editor);
		const target = base.find(`div.zes-${code}`);
		const top = target.offset().top - base.offset().top + base.scrollTop() - header;
		base.animate({scrollTop: top}, 1000 * .4);
	}

	Layout.info();
	StoresBasket.setIndex(basket);
	Product.load(product, session, seller);

	Product.subscribe(data => {
		if (data.config && data.config.scroll) {
			editorScroll();
			$Product.config.scroll = false;
		}
	});

	Menu.subscribe(data => {
		menu = !!data.open;
		if (data.scroll) {
			menuScroll(data.scroll);
			data.scroll = '';
		}
	});

	window.addEventListener('orientationchange', () => {
		const resized = () => {
			containerSize();
			window.removeEventListener('resize', resized);
			window.location.replace(window.location.href);
		};

		window.addEventListener('resize', resized);
		load_remove = false;
		load_hide = false;
	});

	onMount(() => {
		containerSize();
		$Widget.container = editor
	});
</script>

<style>

	:global(body div.zes-container) {
		--zes-background-primary: #FFF;
		--zes-background-secondary: #EEE;
		--zes-1-1: hsl(206deg 75% 25%);
		--zes-1-2: hsl(206deg 75% 44%);
		--zes-1-3: hsl(200deg 75% 55%);
		--zes-1-4: hsl(206deg 75% 44% / .1);
		--zes-2-1: hsl(95deg 70% 30%);
		--zes-2-2: hsl(95deg 70% 40%);
		--zes-2-3: hsl(95deg 85% 50%);
		--zes-3-1: hsl(0deg 0% 30%);
		--zes-3-2: hsl(0deg 0% 60%);
		--zes-4-1: hsl(0deg 70% 30%);
		--zes-4-2: hsl(0deg 70% 40%);
		--zes-4-3: hsl(0deg 85% 50%);
	}

	:global(div[data-shop="schipper"] div.zes-container) {
		--zes-background-primary: #FFF;
		--zes-background-secondary: #EEE;
		--zes-1-1: hsl(0deg 0% 15%);
		--zes-1-2: hsl(0deg 0% 30%);
		--zes-1-3: hsl(0deg 0% 45%);
		--zes-1-4: hsl(0deg 0% 40% / .1);
		--zes-2-1: hsl(95deg 70% 30%);
		--zes-2-2: hsl(95deg 70% 40%);
		--zes-2-3: hsl(95deg 85% 50%);
		--zes-3-1: hsl(0deg 0% 30%);
		--zes-3-2: hsl(0deg 0% 60%);
		--zes-4-1: hsl(0deg 70% 30%);
		--zes-4-2: hsl(0deg 70% 40%);
		--zes-4-3: hsl(0deg 85% 50%);
	}

	:global(div[data-shop="schipper"] div.zes-container-groups-logo) {
		display: none !important;
	}

	:global(div.header > a) {
		display: none !important;
	}

	/* Configurator */

	div.zes-container {
		position: relative;
		display: flex;
		height: 100%;
		color: hsl(0deg 0% 20%);
	}

	div.zes-next {
		position: absolute;
		top: 0;
		height: 3px;
		width: 0%;
		background: var(--zes-1-1);
		z-index: 50;
		transition: width .2s ease-out;
		will-change: width;
	}

	/* Groups */

	div.zes-container-groups {
		display: flex;
		flex-direction: column;
		padding-top: 2em;
		border-right: 1px solid hsl(0deg 0% 85%);
		width: 55%;
		background-image:
			url(/e2/zonscherm/site/content/shop/configure/media/icon.svg);

		background-color: var(--zes-background-primary);
		background-repeat: no-repeat, repeat;
		background-position: -3em 101%, center;
		background-size: 170%, 100%;
	}

	div.zes-container-groups-logo {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 1.5em 1.25em;
	}

	div.zes-container-groups-logo img {
		margin-bottom: .75em;
		max-width: 90%;
		opacity: .5;
	}

	div.zes-container-groups-logo span {
		font-size: .7em;
		text-align: center;
		color: var(--zes-3-1);
		display: block;
		margin-bottom: 1em;
	}

	div.zes-container-groups-logo div i {
		margin-left: .25em;
	}

	/* Editor */

	div.zes-container-editor {
		display: flex;
		width: 60%;
	}

	div.zes-container-editor-menu {
		display: flex;
		width: 40%;
	}

	div.zes-container-editor-content {
		display: flex;
		flex-direction: column;
		width: 60%;
	}

	div.zes-container-editor-layout {
		flex-grow: 1;
		padding-top: 2em;
		background: linear-gradient(90deg, hsl(0deg 0% 95%) 0%, hsl(0deg 100% 100%) 2%, hsl(0deg 100% 100%) 100%);
	}

	div.zes-container-editor-layout-box {
		padding: 1em 1.25em;
	}

	div.zes-container-preview {
		display: flex;
		flex-direction: column;
		position: relative;
		width: 40%;
		background: linear-gradient(180deg, hsl(206deg 75% 44%) 0%, hsl(200deg 75% 55%) 25%, hsl(50, 28%, 89%) 90%);
	}

	/* Resolutions */

	@media only screen and (min-width: 400px) { div.zes-container { font-size: .575em; } }
	@media only screen and (min-width: 500px) { div.zes-container { font-size: .6em; } }
	@media only screen and (min-width: 600px) { div.zes-container { font-size: .625em; } }
	@media only screen and (min-width: 700px) { div.zes-container { font-size: .65em; } }
	@media only screen and (min-width: 800px) { div.zes-container { font-size: .675em; } }
	@media only screen and (min-width: 900px) { div.zes-container { font-size: .7em; } }
	@media only screen and (min-width: 1000px) { div.zes-container { font-size: .725em; } }
	@media only screen and (min-width: 1100px) { div.zes-container { font-size: .75em; } }
	@media only screen and (min-width: 1200px) { div.zes-container { font-size: .775em; } }
	@media only screen and (min-width: 1300px) { div.zes-container { font-size: .8em; } }
	@media only screen and (min-width: 1400px) { div.zes-container { font-size: .825em; } }
	@media only screen and (min-width: 1500px) { div.zes-container { font-size: .85em; } }
	@media only screen and (min-width: 1600px) { div.zes-container { font-size: .9em; } }
	@media only screen and (min-width: 1700px) { div.zes-container { font-size: 1em; } }

	/* Orientation */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-container {
			font-size: .85em;
			flex-direction: column;
			overflow: hidden;
		}

		div.zes-container-groups {
			flex-grow: 1;
			padding-top: 1em;
			border-right: none;
			background-size: 130%, 100%;
		}

		div.zes-container-editor {
			width: 100%;
			height: calc(100% - 3.75em);
			transition: height .25s ease-out;
			will-change: height;
		}

		div.zes-container-editor.zes-renderer {
			height: 60%;
		}

		div.zes-container-editor-menu {
			position: absolute;
			z-index: 100;
			height: 40%;
			width: 100%;
			top: calc(100% - 3.75em);
			transition: top .25s ease-out, height .25s ease-out;
			will-change: top, height;
		}

		div.zes-container-editor-menu.zes-show {
			top: 0;
			height: calc(100% - 3.75em);
		}

		div.zes-container-editor-menu.zes-show.zes-renderer {
			height: 60%;
		}

		div.zes-container-editor-content {
			position: absolute;
			width: 100%;
			height: calc(100% - 3.75em);
			transition: height .25s ease-out;
			will-change: height;
		}

		div.zes-container-editor-content.zes-renderer {
			height: 60%;
		}

		div.zes-container-editor-layout {
			padding-top: 1em;
		}

		div.zes-container-preview {
			width: 100%;
			height: 40%;
			position: absolute;
			top: calc(100% - 3.75em);
			z-index: 200;
			transition: top .25s ease-out;
			will-change: top;
		}

		div.zes-container-preview.zes-renderer {
			top: 60%;
		}
	}

	@media only screen and (min-width: 768px) and (max-width: 1200px) and (orientation: landscape) {
		div.zes-container {
			font-size: .7em;
		}
	}
</style>

<div bind:this="{container}" class="zes-container">
	{#if $Next.active}
		<div bind:this="{next}" class="zes-next" style="width: {$Next.progress}%"></div>
	{/if}
	<div class:zes-renderer="{$Registry.configurator_renderer}" class="zes-container-editor">
		<div class:zes-show="{menu}" class:zes-renderer="{$Registry.configurator_renderer}" class="zes-container-editor-menu">
			<Products/>
			<Steps/>
			<div class="zes-container-groups zes-scroll">
				<svelte:component this="{$Layout.menu}"/>
				<div class="zes-container-groups-logo">
					<img src="/e2/zonscherm/site/content/shop/configure/media/logo_black.svg"/>
					<span>Product Configurator</span>
				</div>
			</div>
		</div>
		<div class:zes-renderer="{$Registry.configurator_renderer}" class="zes-container-editor-content">
			<div bind:this="{editor}" class="zes-container-editor-layout zes-scroll">
				<svelte:component this="{$Layout.title}"/>
				<div class="zes-container-editor-layout-box">
					<EditorBasket/>
					<EditorWarning/>
					<svelte:component this="{$Layout.editor}"/>
				</div>
			</div>
			<Toolbar/>
		</div>
	</div>
	<div class:zes-renderer="{$Registry.configurator_renderer}" class="zes-container-preview {$Registry.configurator_style}">
		<Header/>
		<Media resource="{resource}"/>
		<Gallery/>
	</div>
	<Loader/>
</div>

<Styles/>